import { ViewFactory } from 'wdc-cube-react'
import CondicaoFormScope from '../condicao_form.scopes'
import { CondicaoFormView } from './condicao_form.view'

export function registerViews(rv = ViewFactory.register) {
    rv(CondicaoFormScope, CondicaoFormView)
}
